import { render } from "./C4Page.vue?vue&type=template&id=31ad600e"
import script from "./C4Page.vue?vue&type=script&lang=js"
export * from "./C4Page.vue?vue&type=script&lang=js"

import "./C4Page.vue?vue&type=style&index=0&id=31ad600e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__